import {UIActionTypes} from "./constants";

const initialState = {
    loading: false,
    ui: {},
    user: {},
    chatrooms: [],
    currentRequest: {services: []},
    currentRequestLoading: false,
    image: null,
    awaitingSupervisorList: [],
    selectedAwaitingSupervisorItem: null,
    messages: [],
    selectedRoom: null,
    locallySendMessages: {},
    locallySendMessagesRecipients: {},
    activeUsers: [],
    vox: {
        calling: null,//'CALL' | 'RING' | null
        currentCall: null,
        sdk: null,
        callType: null, // 'VOICE'|'VOIP'|'VIDEO',
        inCall: false,
        muteMicrophone: false
    }
};
const uiReducer = (
    state: any = initialState,
    action: { type: string, payload?: any },
): any => {
    switch (action.type) {
        case 'UPDATE':
            return {
                ...state,
                ...action.payload,
            };
        case 'VOX_UPDATE':
            return {
                ...state,
                vox: {
                    ...state.vox,
                    ...action.payload
                }
            };
        case UIActionTypes.UPDATE_REQUEST:
            return {
                ...state,
                currentRequest: {
                    ...action.payload
                }
            }
        case UIActionTypes.CLEAR_REQUEST:
            return {
                ...state,
                currentRequest: null
            }
    }
    return state;
};

export default uiReducer;
